module.exports = __webpack_public_path__ + "media/images/flags/it-08db2cd122d5f99494dd35c2cfb10784.svg";